"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuarterbackDefendingUnit = exports.QuarterbackOffensiveUnit = void 0;
/**
 * The offensive unit associated with a specific quarterback matchup.
 * @public
 */
var QuarterbackOffensiveUnit;
(function (QuarterbackOffensiveUnit) {
    /** Pass block */
    QuarterbackOffensiveUnit["PassBlock"] = "pass-block";
    /** Wide receiver receiving */
    QuarterbackOffensiveUnit["WideReceiverReceiving"] = "wr-receiving";
    /** Tight end receiving */
    QuarterbackOffensiveUnit["TightEndReceiving"] = "te-receiving";
    /** Running back receiving */
    QuarterbackOffensiveUnit["RunningBackReceiving"] = "rb-receiving";
})(QuarterbackOffensiveUnit || (exports.QuarterbackOffensiveUnit = QuarterbackOffensiveUnit = {}));
/**
 * The defending unit associated with a specific quarterback matchup.
 * @public
 */
var QuarterbackDefendingUnit;
(function (QuarterbackDefendingUnit) {
    /** Pass defense */
    QuarterbackDefendingUnit["PassDefense"] = "pass-defense";
    /** Pass rush */
    QuarterbackDefendingUnit["PassRush"] = "pass-rush";
    /** Wide receiver coverage */
    QuarterbackDefendingUnit["WideReceiverCoverage"] = "wr-coverage";
    /** Tight end coverage */
    QuarterbackDefendingUnit["TightEndCoverage"] = "te-coverage";
    /** Running back coverage */
    QuarterbackDefendingUnit["RunningBackCoverage"] = "rb-coverage";
})(QuarterbackDefendingUnit || (exports.QuarterbackDefendingUnit = QuarterbackDefendingUnit = {}));
//# sourceMappingURL=quarterback_matchups.js.map